module.exports = __webpack_public_path__ + "static/img/logo1.4471f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.png
// module id = LJ2z
// module chunks = 3